// @ts-nocheck
(function () {
  'use strict';

  const ADDON_CONFIG = {
    assembly: {
      flag: 'assembly',
      variantId: 'assemblyVariantId',
      price: 'assemblyAddonPrice'
    },
    remove_bed: {
      flag: 'removeBed',
      variantId: 'removeBedVariantId',
      price: 'removeBedAddonPrice'
    },
    remove_mattress: {
      flag: 'removeMattress',
      variantId: 'removeMattressVariantId',
      price: 'removeMattressAddonPrice'
    },
    room_of_choice_delivery: {
      flag: 'roomOfChoiceDelivery',
      variantId: 'roomOfChoiceDeliveryVariantId',
      price: 'roomOfChoiceDeliveryAddonPrice'
    }
  };

  function ensureState() {
    window.pdpState = window.pdpState || {};
    return window.pdpState;
  }

  function normalizeLoose(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function uniq(values) {
    const out = [];
    const seen = new Set();
    for (const v of values || []) {
      const key = normalizeLoose(v);
      if (!key) continue;
      if (seen.has(key)) continue;
      seen.add(key);
      out.push(v);
    }
    return out;
  }

  function parseAddonsProp(raw) {
    if (!raw) return [];
    if (Array.isArray(raw)) return uniq(raw);
    const s = String(raw);
    const trimmed = s.trim();
    if (!trimmed) return [];

    if (trimmed[0] === '[') {
      try {
        const arr = JSON.parse(trimmed);
        if (Array.isArray(arr)) return uniq(arr);
      } catch (_e) { }
    }

    return uniq(trimmed.split(',').map((x) => x.trim()).filter(Boolean));
  }

  function getAddonLabels(addonKey) {
    switch (addonKey) {
      case 'assembly':
        return ['Professional Assembly', 'Assembly'];
      case 'remove_bed':
        return ['Bed Removal', 'Bed Recycling', 'Removal of Bed', 'Recycle Bed'];
      case 'remove_mattress':
        return ['Mattress Removal', 'Mattress Recycling', 'Removal of Mattress', 'Recycle Mattress'];
      case 'room_of_choice_delivery':
        return ['Room of Choice Delivery', 'Room of choice'];
      default:
        return [addonKey];
    }
  }

  async function fetchCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!res.ok) throw new Error('Failed to fetch cart');
    return await res.json();
  }

  function shouldDebug() {
    try {
      return window.location && window.location.search && window.location.search.indexOf('sonno_debug=1') >= 0;
    } catch (_e) {
      return false;
    }
  }

  function getParentProductIdFromPage() {
    const el = document.querySelector('.pdp-addons-2[data-parent-product-id]');
    const id = el ? el.getAttribute('data-parent-product-id') : '';
    return id ? String(id) : '';
  }

  function findMainLinesForProduct(cart, productId) {
    const pid = String(productId || '');
    if (!pid) return [];
    return (cart.items || []).filter((it) => String(it.product_id || '') === pid);
  }

  function cartHasAddonForProduct(_cart, _productId, _addonKey) {
    // Disabled on purpose.
    // Reason: product_id is shared across multiple cart lines; syncing based on cart
    // marks addons as selected for new configurations and for other cart instances.
    return false;
  }

  function dispatchStateChanged(source) {
    try {
      window.dispatchEvent(new CustomEvent('sonno:pdpStateChanged', { detail: { source } }));
    } catch (e) { }
  }

  function toPounds(price) {
    if (typeof price === 'number') {
      // Shopify variant JSON uses cents as integers.
      return price > 999 ? price / 100 : price;
    }
    const n = parseFloat(price);
    if (!isFinite(n)) return 0;
    return n > 999 ? n / 100 : n;
  }

  function formatMoney(pounds) {
    if (window.pdpPricing && typeof window.pdpPricing.formatMoney === 'function') {
      return window.pdpPricing.formatMoney(pounds);
    }
    const n = parseFloat(pounds) || 0;
    return '£' + n.toLocaleString('en-GB', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  function parseVariantsJson(addonKey) {
    const el = document.querySelector(
      `script[data-sonno-addon-variants][data-addon-key="${addonKey}"]`
    );
    if (!el) return [];
    try {
      return JSON.parse(el.textContent || '[]') || [];
    } catch (e) {
      return [];
    }
  }

  function getSelectedSizeLower() {
    const state = ensureState();
    const size = state.size ? String(state.size) : '';
    return size.toLowerCase();
  }

  // Safe partial size match: prevents "king" matching "super king".
  function safeSizePartialMatch(a, b) {
    if (!a || !b) return false;
    const wa = a.trim().toLowerCase().split(/\s+/);
    const wb = b.trim().toLowerCase().split(/\s+/);
    if (wa.length === wb.length) return false;
    const shorter = wa.length < wb.length ? wa : wb;
    const longer = wa.length < wb.length ? wb : wa;
    return shorter.every(w => longer.includes(w));
  }

  function findBestVariantForSize(variants, sizeLower) {
    if (!variants || !variants.length) return null;

    if (sizeLower) {
      const exact = variants.find(
        (v) => String(v?.title || '').toLowerCase() === sizeLower
      );
      if (exact) return exact;
      // Safe partial match: prevents "king" matching "super king"
      const partial = variants.find(
        (v) => safeSizePartialMatch(sizeLower, String(v?.title || '').toLowerCase())
      );
      if (partial) return partial;
    }

    // Only fallback to first variant if no size was specified.
    // If size was specified but no match found, return null to prevent wrong-size addon.
    if (!sizeLower) return variants.find((v) => v && v.available) || variants[0] || null;
    return null;
  }

  function updateButtonUI(btn, isSelected) {
    if (!btn) return;
    if (isSelected) {
      btn.textContent = 'Remove';
      btn.style.backgroundColor = 'transparent';
      btn.style.color = 'var(--clr-text)';
      btn.style.fontWeight = 'var(--fw-medium)';
      btn.style.textDecoration = 'underline';
    } else {
      btn.style.textDecoration = '';
      btn.textContent = 'Add';
      btn.style.color = '';
      btn.style.backgroundColor = '';
      btn.style.fontWeight = '';
    }
  }

  function updatePriceUI(priceEl, pounds) {
    if (!priceEl) return;
    priceEl.textContent = formatMoney(pounds);
  }

  function syncVariantForAddon(addonKey, btn, priceEl) {
    const variants = parseVariantsJson(addonKey);
    const sizeLower = getSelectedSizeLower();

    const v = findBestVariantForSize(variants, sizeLower);
    if (!v) return null;

    const pounds = toPounds(v.price);

    btn.setAttribute('data-variant-id', String(v.id));
    btn.setAttribute('data-price', String(pounds));

    updatePriceUI(priceEl, pounds);

    return { id: String(v.id), pounds };
  }

  function updatePricingStateForAddon(addonKey, isSelected) {
    const state = ensureState();
    const cfg = ADDON_CONFIG[addonKey];
    if (!cfg) return;

    const btn = document.querySelector(
      `.pdp-addons-2[data-addon="${addonKey}"] [data-addon-toggle][data-addon-key="${addonKey}"]`
    );

    const currentVariantId = btn?.getAttribute('data-variant-id') || null;
    const currentPrice = parseFloat(btn?.getAttribute('data-price') || '0') || 0;

    // Ensure fields exist
    if (typeof state[cfg.flag] !== 'boolean') state[cfg.flag] = false;
    if (typeof state[cfg.price] !== 'number') state[cfg.price] = 0;

    state[cfg.flag] = Boolean(isSelected);
    state[cfg.variantId] = isSelected ? currentVariantId : null;
    state[cfg.price] = isSelected ? currentPrice : 0;

    if (window.pdpPricing && typeof window.pdpPricing.updatePrice === 'function') {
      window.pdpPricing.updatePrice();
    }
  }

  function initAddonBlock(blockEl) {
    if (!blockEl || blockEl.dataset.sonnoAddonInit === '1') return;

    const addonKey = blockEl.getAttribute('data-addon');
    const cfg = ADDON_CONFIG[addonKey];
    if (!cfg) return;

    const btn = blockEl.querySelector(`[data-addon-toggle][data-addon-key="${addonKey}"]`);
    if (!btn) return;

    const priceEl = blockEl.querySelector('[data-addon-price]');

    blockEl.dataset.sonnoAddonInit = '1';

    const state = ensureState();

    // Initialize defaults if missing.
    if (typeof state[cfg.flag] !== 'boolean') state[cfg.flag] = false;
    if (typeof state[cfg.variantId] === 'undefined') state[cfg.variantId] = null;
    if (typeof state[cfg.price] !== 'number') state[cfg.price] = 0;

    // Never preselect on PDP; selection should be explicit on this page.
    state[cfg.flag] = false;
    state[cfg.variantId] = null;
    state[cfg.price] = 0;

    // Initial sync
    const synced = syncVariantForAddon(addonKey, btn, priceEl);
    if (state[cfg.flag] && synced) {
      state[cfg.variantId] = synced.id;
      state[cfg.price] = synced.pounds;
    }

    updateButtonUI(btn, state[cfg.flag]);

    // Ensure totals reflect current selection.
    updatePricingStateForAddon(addonKey, state[cfg.flag]);

    btn.addEventListener('click', function (e) {
      e.preventDefault();

      const stateNow = ensureState();
      const nextSelected = !stateNow[cfg.flag];

      // Always resync before applying selection so variant/price match latest size.
      syncVariantForAddon(addonKey, btn, priceEl);

      updateButtonUI(btn, nextSelected);
      updatePricingStateForAddon(addonKey, nextSelected);

      dispatchStateChanged(`${addonKey}-addon`);
    });
  }

  function initAll() {
    const blocks = document.querySelectorAll('.pdp-addons-2[data-addon]');
    blocks.forEach(initAddonBlock);
  }

  async function syncSelectionsFromCart() {
    const productId = getParentProductIdFromPage();
    if (!productId) return;

    // Only sync on PDP (not cart), where state may be stale.
    const path = (window.location && window.location.pathname) ? String(window.location.pathname) : '';
    if (path === '/cart' || path.indexOf('/cart') === 0) return;

    let cart;
    try {
      cart = await fetchCart();
    } catch (e) {
      return;
    }

    if (shouldDebug()) {
      const mains = findMainLinesForProduct(cart, productId);
      console.groupCollapsed('[SonnoPdpDebug] cart sync');
      // console.log('productId:', productId);
      // console.log('mainLinesForProduct:', mains.length);
      if (mains.length) {
        console.table(mains.map((m) => ({ key: m.key, title: m.title, qty: m.quantity })));
      }
      console.groupEnd();
    }

    const state = ensureState();
    let changed = false;

    Object.keys(ADDON_CONFIG).forEach((addonKey) => {
      const cfg = ADDON_CONFIG[addonKey];
      if (!cfg) return;

      // Only sync addons that exist on the page.
      const block = document.querySelector(`.pdp-addons-2[data-addon="${addonKey}"]`);
      if (!block) return;

      const selectedInCart = cartHasAddonForProduct(cart, productId, addonKey);
      if (typeof state[cfg.flag] !== 'boolean') state[cfg.flag] = false;

      // We do not auto-select addons based on cart state.
      // Clear any stale true values so the PDP never shows "Remove" by default.
      if (state[cfg.flag] === true) {
        state[cfg.flag] = false;
        changed = true;
      }

      // selectedInCart is intentionally ignored.
      void selectedInCart;
    });

    if (changed) {
      dispatchStateChanged('cart-sync');
      // Also update button UI immediately
      document.querySelectorAll('.pdp-addons-2[data-addon]').forEach((blockEl) => {
        const addonKey = blockEl.getAttribute('data-addon');
        const cfg = ADDON_CONFIG[addonKey];
        if (!cfg) return;
        const btn = blockEl.querySelector(`[data-addon-toggle][data-addon-key="${addonKey}"]`);
        if (!btn) return;
        updateButtonUI(btn, Boolean(state[cfg.flag]));
        updatePricingStateForAddon(addonKey, Boolean(state[cfg.flag]));
      });
    }
  }

  function onStateChanged() {
    const blocks = document.querySelectorAll('.pdp-addons-2[data-addon]');
    blocks.forEach((blockEl) => {
      const addonKey = blockEl.getAttribute('data-addon');
      const cfg = ADDON_CONFIG[addonKey];
      if (!cfg) return;

      const btn = blockEl.querySelector(`[data-addon-toggle][data-addon-key="${addonKey}"]`);
      if (!btn) return;

      const priceEl = blockEl.querySelector('[data-addon-price]');

      const res = syncVariantForAddon(addonKey, btn, priceEl);
      const state = ensureState();

      if (state[cfg.flag] && res) {
        state[cfg.variantId] = res.id;
        state[cfg.price] = res.pounds;
        if (window.pdpPricing && typeof window.pdpPricing.updatePrice === 'function') {
          window.pdpPricing.updatePrice();
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('DOMContentLoaded', () => { void syncSelectionsFromCart(); });
  } else {
    initAll();
    void syncSelectionsFromCart();
  }

  window.addEventListener('sonno:pdpStateChanged', onStateChanged);
})();
